import UserDataService from 'common/services/userData.service.js';

class FoodUserDataService extends UserDataService{
  constructor() {
    super();
  }

}

export default FoodUserDataService;



// WEBPACK FOOTER //
// ./client/app/food-benefit.module/common/services/foodUserData.service.js